'use strict';

// include after jQuery, but before app.js/utilities.js/sections.js
// note - see bottom for some code that runs at startup!!

( function() { // skipping the indention for readability


// ******************************************************************************** globals / module
// we can put our custom functions into a module named after the store
window.TCF = window.TCF || {};

TCF.data = TCF.data || {};

// note - see bottom for some code that runs at startup!!



// ******************************************************************************** helper functions
function _get_title_image_pairs_for_unavailable_variants (product) {
    var unavailable_variants = [];
    product.variants.forEach(function(variant, index) {
        if (!variant.available) {
            unavailable_variants.push({
                title: variant.title, // for select dropdowns
                featured_image_id: variant.featured_image ? variant.featured_image.id : null, // for thumbs
                index: index // for thumbs on quick shop
            });
        }
    });
    return unavailable_variants;
};

function _append_sold_out_to_variant_dropdown (unavailable_variants) {
        $('.selector-wrapper')
            .find('option')
            .filter(function(){
                return unavailable_variants
                        .map(function(variant) {
                            return variant.title;
                        })
                        .indexOf(this.value) !== -1;
            })
            .filter(function(index, element){
                // exclude elements we did this for already
                return !element.text.includes('SOLD OUT');
            })
            .append(' --- SOLD OUT ---');
};

// unavailable variants is a list
function _add_thumb_overlay_to_unavailabe_variants (unavailable_variants, is_quick_shop, product) {
    if (is_quick_shop) {
        var i;
        var variant;
        var gallery_index;
        var $containing_element;

        for (i = 0; i < unavailable_variants.length; i++) {
            variant = unavailable_variants[i];
            gallery_index = $('[data-image-id="' + variant.featured_image_id + '"]').data('index');
            $containing_element = $('.product_gallery_nav .gallery-cell').eq(gallery_index);

            if ($containing_element.classlist &&
                    $containing_element.classlist.contains('product-thumb--out-of-stock')) {
                // ie, do not apply this twice
                continue;
            }

            $containing_element.addClass('product-thumb--out-of-stock');
        }

    } else {
        $('.product-' + product.id + '-gallery-nav')
                .find('.gallery-cell')
                .filter(function() {
                    return unavailable_variants
                            .map(function(variant) {
                                return variant.featured_image_id;
                            })
                            .indexOf(parseInt(this.getElementsByTagName('img')[0].dataset.imageId)) !== -1;
                })
                .addClass('product-thumb--out-of-stock');
    }
}

function _create_image_to_options_map (product) {
    // image_to_options_map maps between the featured_image src of each variant to another
    // mapping between each option key and its value
    // ie, lets you take an image's processed src attribute and find which option it corresponds to
    // top level key is a uri
    // some_option_key will be option-0 and will refer to color for us

    // eg,
    // {
    //      "foo.com/bar.jpeg": {
    //          "some_option_key": "some_option_value",
    //          "another_option_key": "another_option_value"
    //      }
    // }
    var image_to_options_map = {};

    product.variants.forEach(function(variant) {
        if (variant.featured_image) {
            var image_src = variant
                    .featured_image.src
                    .split('?')[0]
                    .replace(/http(s)?:/,'');
            // recall, we are mapping between strings and other maps
            image_to_options_map[image_src] = image_to_options_map[image_src] || {};

            // recall, product options are things like color and size, and a variant just a
            // unique combination of options.
            product.options.forEach(function(ignore_me, index) {
                var option_value = variant.options[index];
                var option_key = 'option-' + index;

                if (!image_to_options_map[image_src][option_key]) {
                    image_to_options_map[image_src][option_key] = option_value;
                } else {
                    var old_option_value = image_to_options_map[image_src][option_key];
                    if (old_option_value !== null && old_option_value !== option_value) {
                        image_to_options_map[image_src][option_key] = null;
                    }
                }
            });
        }
    });
    return image_to_options_map;
};



// ************************************************************** core functions
TCF.mark_unavailable_variants_as_sold_out = function(product, is_quick_shop) {
    var unavailable_variants = _get_title_image_pairs_for_unavailable_variants(product);
    _append_sold_out_to_variant_dropdown(unavailable_variants);
    _add_thumb_overlay_to_unavailabe_variants(unavailable_variants, is_quick_shop, product);
};

TCF.determine_if_product_is_sold_by_the_yard = function(tags) {
    for (var i = 0; i < tags.length; i++) {
        if (tags[i].toLowerCase() === 'yardage') {
            return true;
        }
    }
    return false;
};

// eg, if on a product page, there is an image carousel on the left with product variant thumbnails.
// the other function made this one obsolete. Its being kept temporarily as code reference
// because its a modified version of shopify code
TCF.setup_clicks_on_thumbnails_to_change_selected_variant = function (product, thumbnails_selector) {
    // var image_to_options_map = _create_image_to_options_map(product);

    // // previously from app.js.liquid, probably to have it trigger at the end of the page load?
    // var $thumbnails = $(thumbnails_selector);
    // if ($thumbnails.length) {
    //     $thumbnails.off('click'); // we don't want to add multiple listeners
    //     $thumbnails.click(function () {
    //         // image_sec_split_on_period excludes any query string that may be found
    //         var image_src_split = $(this).attr('src')
    //                 .split('?')[0] // intends to remove query string
    //                 .split('.');
    //         var img_src_extension = image_src_split.pop();
    //         var img_src_minus_trailing = image_src_split
    //                 .pop()
    //                 .replace(/_[a-zA-Z0-9@]+$/, '');
    //         var img_src = image_src_split.join('.') +
    //                 "." + img_src_minus_trailing +
    //                 "." + img_src_extension;
    //         if (typeof image_to_options_map[img_src] === 'undefined') {
    //             return;
    //         }

    //         product.variants.forEach(function (variant, i) {
    //             // warning - this assumes variants only use one option.
    //             // Could lead to a bug one day

    //             // this used to be option-i
    //             // That assumes we're iterating over option values. However,
    //             // we are iterating over variants, so it was broken.
    //             // It was shopify code, hence the wordy comment to explain the change
    //             // note - option_value is a string, eg, "Dawn" or "Earth"
    //             var option_value = image_to_options_map[img_src]['option-0'];

    //             var options_matching_value = $('.single-option-selector option')
    //                 .filter(function () {
    //                     return $(this).text()
    //                         .replace('--- SOLD OUT ---', '')
    //                         .trim() === option_value
    //                 });
    //             if (options_matching_value.length && option_value !== null ) {
    //                 // warning: there is a duplicate single-option-selector hiding in the DOM
    //                 // that does nothing but mess with us. The .not is critical
    //                 $('.single-option-selector')
    //                         .not('.info select')
    //                         .val(option_value)
    //                         .trigger('change');
    //             }
    //         });
    //     });
    // }
};

TCF.setup_clicks_in_gallery_to_change_selected_variant = function (product) {
    var gallery_index_to_variant_map = {};

    var i;
    var variant;
    var gallery_index;
    var gallery_indices = [];
    for (i = 0; i < product.variants.length; i++) {
        variant = product.variants[i];
        gallery_index = $('[data-image-id="' + (variant.featured_image ? variant.featured_image.id : null) + '"]').data('index');

        if (gallery_index === undefined || gallery_index === null) {
            continue;
        }
        gallery_index_to_variant_map[gallery_index] = variant;
    }


    // add event listener to the flickity.change event
    // note - this usually fires twice, once when there is not actually any change.
    // the one that does not reflect a change  has index === undefined
    $('body').off( 'change.flickity');
    $('body').on( 'change.flickity', function( event, index ) {

        if (index === undefined) {
            return;
        }
        variant = gallery_index_to_variant_map[index];
        if (!variant) return; // sometimes an image does not have a variant associated

        // warning - presupposes single-option variants! coud lead to a bug one day
        // warning - the .not() is crucial. there is an invisible trap single-option-selector
        $('.single-option-selector').not('.info select').val(variant.option1).trigger('change');
    });
};

TCF.get_items_left_text = function (shopify_inventory_quantity, product_is_sold_by_the_yard) {
    var items_left_text = null;
    if (product_is_sold_by_the_yard) {
        if (shopify_inventory_quantity === 4) {
            items_left_text = 'yard left'; // 4 inventory items is 1 yard
        } else {
            items_left_text = 'yards left';
        }
    } else {
        if (shopify_inventory_quantity === 1) {
            items_left_text = Shopify.translation.one_item_left;
        } else {
            items_left_text = Shopify.translation.items_left_text;
        }
    }
    return items_left_text;
};

TCF.element_has_class = function($element, the_class) {
    var element_has_the_class = false;
    var classList = $element.attr('class').split(/\s+/);
    $.each(classList, function(index, class_name) {
        if (class_name === the_class) {
            element_has_the_class = true;
        }
    });
    return element_has_the_class;
};

TCF.string_replace_all = function(str, target_substring, replace_with_this) {
    return str.split(target_substring).join(replace_with_this);
}

// code to hide out of stock products not in use. Saved for future reference

// TCF.hide_out_of_stock_products = function(item_visibility_toggle) {
//     // remove elements / initialize hidden_products if necessary
//     if (TCF.data.hidden_products === null) { // null is the sentinel value
//         TCF.data.hidden_products = $('.product-loop-container__out-of-stock').detach();
//     }
//     else {
//         $('.product-loop-container__out-of-stock').remove();
//     }

//     // update button text
//     item_visibility_toggle.text('Show Out of Stock Products');
//     TCF.data.out_of_stock_items_are_hidden = true;
// }

// TCF.show_out_of_stock_products = function(item_visibility_toggle) {
//     TCF.data.hidden_products.appendTo('.product-list');
//     TCF.data.out_of_stock_items_are_hidden = false;
//     item_visibility_toggle.text('Hide Out of Stock Products');
// }

// TCF.update_out_of_stock_preference_cookie = function(should_hide) {
//     if (should_hide) {
//         var one_day_in_seconds = 60*60*24;
//         document.cookie =
//                 'hide_out_of_stock_products=true;' +
//                 'domain=' + window.location.hostname + ';' +
//                 'path=/;' +
//                 'samesite=strict;' +
//                 'max-age=' + one_day_in_seconds + ';';
//     } else {
//         document.cookie =
//                 'hide_out_of_stock_products=;' +
//                 'domain=' + window.location.hostname + ';' +
//                 'path=/;' +
//                 'samesite=strict;' +
//                 'expires=Thu, 01 Jan 1970 00:00:00 UTC;';
//     }
// }

})(); // closing the IIFE



// ************************************************************************** code to run on startup
// this simply handles the out-of-stock item visibility. If this run-on-startup code
// is expanded at all, it should be refactored into proper functions and objects

// $().ready(function() {
//     TCF.data.out_of_stock_items_are_hidden = false;
//     TCF.data.hidden_products = null; // null is the sentinel value

//     // at time of writing, this button lived in the collection-template
//     var item_visibility_toggle = $('#button--toggle-visibility-of-out-of-stock-items');

//     item_visibility_toggle.click(function() {
//         if (!TCF.data.out_of_stock_items_are_hidden) { // if they are visible
//             TCF.hide_out_of_stock_products(item_visibility_toggle);
//             TCF.update_out_of_stock_preference_cookie(true);
//         } else { // if they are hidden
//             TCF.show_out_of_stock_products(item_visibility_toggle);
//             TCF.update_out_of_stock_preference_cookie(false);
//         }
//     });

//     // do on load, as long as
//         // 1) is collections page,
//         // 2) is not product page,
//         // 3) hidden preference cookie is set
//     if (window.location.pathname.includes('collections') &&
//             !window.location.pathname.includes('product') &&
//             document.cookie.includes('hide_out_of_stock_products=true')) {

//         TCF.hide_out_of_stock_products(item_visibility_toggle);
//         TCF.update_out_of_stock_preference_cookie(true);
//     }
// });
